import { useState, useEffect } from 'react';
import { Modal, Form, Select, Input, Button, Row, Col, Typography } from 'antd';

const { Option } = Select;

function AddConditionModal({
  attributes,
  conditionList,
  setConditionList,
  open,
  onClose,
  editingIndex,
  selectedCondition,
}) {
  const [attributeName, setAttributeName] = useState('');
  const [matchType, setMatchType] = useState('');
  const [algorithm, setAlgorithm] = useState('levenshtein');
  const [threshold, setThreshold] = useState('');
  const [weight, setWeight] = useState('');

  // Prefill values when editing
  useEffect(() => {
    if (selectedCondition) {
      setAttributeName(selectedCondition.attributeName || '');
      setMatchType(selectedCondition.matchType || '');
      setAlgorithm(selectedCondition.algorithm || 'levenshtein');
      setThreshold(selectedCondition.threshold || '');
      setWeight(selectedCondition.weight || '');
    } else {
      setAttributeName('');
      setMatchType('');
      setAlgorithm('levenshtein');
      setThreshold('');
      setWeight('');
    }
  }, [selectedCondition]);

  const handleSave = () => {
    const newCondition = {
      attributeName,
      matchType,
      algorithm,
      threshold,
      weight,
    };

    if (editingIndex !== null) {
      const updated = [...conditionList];
      updated[editingIndex] = newCondition;
      setConditionList(updated);
    } else {
      setConditionList([...conditionList, newCondition]);
    }

    onClose();
  };

  return (
    <Modal
      title={editingIndex !== null ? 'Edit Condition' : 'Add Match Condition'}
      open={open}
      onCancel={onClose}
      footer={null}
      width={600}
      destroyOnClose
      centered
    >
      <Form layout="vertical">
        {/* Attribute */}
        <Form.Item label="Attribute">
          <Select value={attributeName} onChange={setAttributeName} placeholder="Select Attribute">
            {attributes?.map((item, idx) => (
              <Option key={idx} value={item.name}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* Match Type */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Match Type">
              <Select value={matchType} onChange={setMatchType} placeholder="Select Match Type">
                <Option value="exact">Exact Match</Option>
                <Option value="fuzzy">Fuzzy Match</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {matchType === 'fuzzy' && (
          <>
            {/* Algorithm + Threshold */}
            <Row gutter={16}>
              <Col span={16}>
                <Form.Item label="Fuzzy Algorithm">
                  <Select value={algorithm} onChange={setAlgorithm} placeholder="Select Algorithm">
                    <Option value="jaro">Jaro-Winkler</Option>
                    <Option value="levenshtein">Levenshtein</Option>
                    <Option value="cosine">Cosine Similarity</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Threshold">
                  <Input value={threshold} onChange={(e) => setThreshold(e.target.value)} placeholder="e.g. 80" />
                </Form.Item>
              </Col>
            </Row>

            {/* Weight */}
            <Form.Item label="Weight (in overall score)">
              <Input value={weight} onChange={(e) => setWeight(e.target.value)} placeholder="e.g. 10" />
            </Form.Item>
          </>
        )}

        {/* Footer */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={handleSave}>
            {editingIndex !== null ? 'Update' : 'Add'}
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

export default AddConditionModal;
